export default {
    "alarms": {
        "titles": "Tipos de Alarme",
        "title": "Alarme",
        "model": {
            "name": "Nome",
            "active": "Ativo"
        },
        "list": {
            "name": "@:alarms.model.name",
            "active": "@:alarms.model.active"
        }
    },
    "channels": {
        "titles": "Canais de Entrada",
        "title": "Canal de Entrada",
        "list": {
            "name": "Nome",
            "active": "Ativo"
        },
        "model": {
            "name": "Nome",
            "active": "Ativo"
        }
    },
    "cps": {
        "titles": "Serviços Proteção Civil",
        "title": "Serviço Proteção Civil",
        "list": {
            "name": "Nome",
            "parish": "Freguesia"
        },
        "model": {
            "name": "Nome",
            "parish": "Freguesia"
        }
    },
    "expedients": {
        "titles": "Tipos de Expediente",
        "title": "Expediente",
        "model": {
            "name": "Nome",
            "active": "Ativo"
        },
        "list": {
            "name": "@:alarms.name.name",
            "active": "@:alarms.model.active"
        }
    },
    "families": {
        "titles": "Famílias",
        "title": "Família",
        "list": {
            "name": "@:families.model.name",
            "kinds_count": "Nº Espécies",
            "active":  "@:families.model.active"
        },
        "model": {
            "name": "Nome",
            "active": "Ativo",
            "order": "Ordem"
        }
    },
    "kinds": {
        "titles": "Espécies",
        "title": "Espécie",
        "list": {
            "name": "Nome",
            "family": "@:families.title",
            "types_count": "Nº Tipos",
            "active": "@:families.model.active",
        },
        "model": {
            "name": "Nome",
            "family": "@:families.title",
            "active": "Ativo",
            "order": "Ordem"
        }
    },
    "types": {
        "titles": "Tipos",
        "title": "Tipo",
        "list": {
            "name": "Nome",
            "family": "@:families.title",
            "kind": "@:kinds.title",
            "active": "@:types.model.active",
        },
        "model": {
            "name": "Nome",
            "family": "@:families.title",
            "kind": "@:kinds.title",
            "description": "Descrição",
            "active": "Ativo",
            "order": "Ordem",
            "code": "Código",
            "code_anepc": "Código ANEPC",
            "code_edoclink": "Código EdocLink"
        },
    },
    "priorities": {
        "titles": "Importâncias",
        "title": "Importância",
        "list": {
            "name": "Nome",
            "active": "Ativo"
        },
        "model": {
            "name": "Nome",
            "active": "Ativo"
        }
    },
    "statuses": {
        "titles": "Estados",
        "title": "Estado",
        "list": {
            "order": "Ordem",
            "name": "Nome",
            "first_process": "Primeiro",
            "last_process": "Último",
            "guest": "Visível Munícipe",
            "color": "Côr",
            "image": "Imagem",
            "active": "Ativo"
        },
        "model": {
            "name": "Nome",
            "order": "Ordem",
            "transform_to": "Agregar",
            "color": "Côr",
            "first_process": "Estado inicial?",
            "last_process": "Estado final?",
            "report_to": "Permite atribuir?",
            "guest": "Visível ao Munícipe?",
            "description": "Descrição",
            "active": "Ativo"
        },
        "help": {
            "order": "Ordem de apresentação no painel dos filtros",
            "transform_to": "Para o Munícipe, este estado é agregado em ...",
            "first_process": "Atribuir este estado quando um registo é criado?",
            "last_process": "Este estado é final?",
            "report_to": "Define a possibilidade de atribuir o registo a alguma entidade/pessoa",
            "guest": "Este estado é visível para o Munícipe?"
        }
    },
    "entities": {
        "titles": "Entidades",
        "title": "Entidade",
        "list": {
            "name": "Nome",
            "external": "Externa"
        },
        "model": {
            "name": "Nome",
            "external": "Entidade Externa",
            "order": "Ordem"
        }
    },
    "unities": {
        "titles": "Unidades",
        "title": "Unidade",
        "list": {
            "name": "Nome",
            "email": "E-mail",
            "phone": "Contato",
            "entity": "Entidade",
            "agent" : {
                "unity": "@:unities.title",
                "name": "Nome",
                "email": "E-mail",
                "contact": "Contato",
                "placeholder": "Adicionar meios humano...",
                "add": "Adicionar",
                "deleteMsg": "Deseja remover <u>{name}</u>?",
                "notFoundMsg": "Sem meios humanos associados"
            },
            "vehicle" : {
                "code": "Código",
                "name": "Viatura",
                "registration": "Matrícula",
                "radio": "Rádio",
                "placeholder": "Adicionar viatura...",
                "add": "Adicionar",
                "deleteMsg": "Deseja remover a viatura <u>{name}</u>?",
                "notFoundMsg": "Sem viaturas associadas"
            },
            "radio" : {
                "radio_type": "Tipo",
                "code": "Código",
                "placeholder": "Adicionar rádio...",
                "add": "Adicionar",
                "deleteMsg": "Deseja remover o rádio <u>{name}</u>?",
                "notFoundMsg": "Sem rádios associados"
            },
            "tabs" : {
                "commun": "Geral",
                "types": "Áreas/Domínios de intervenção",
                "agents": "Meios humanos",
                "materials": "Meios materiais"
            }
        },
        "model": {
            "name": "Nome",
            "address": "Morada",
            "email": "E-mail",
            "phone": "Contato",
            "lat": "Latitude",
            "lng": "Longitude",
            "n_operational": "Nº de Operacionais",
            "skills": "Competências",
            "entity": "Entidade",
            "vehicles": "Viaturas",
            "radios": "Rádios"
        },
        "help": {
            "email": "É possivel configurar múltiplos e-mails separados por <b>,</b> ou <b>;</b>",
            "phone": "É possivel configurar múltiplos telefone/telemóvel separados por <b>,</b> ou <b>;</b>",
            "n_operational": "@:unities.model.n_operational presentes na @:unities.title",
            "entity": "Configurar entidade a que pertence a unidade.",
            "lat": "Ex - 40° 26′ 46″ N ou 40° 26′ 45.9996″ N",
            "lng": "Ex - 79° 58′ 56″ W ou 79° 58′ 55.2″ E"
        }
    },
    "airbases": {
        "titles": "Centros de Meios Aéreos (CMA)",
        "title": "CMA",
        "list": {
            "name": "Nome",
            "type": "Tipo",
            "district": "Distrito"
        },
        "model": {
            "active": "Operacional",
            "name": "Nome",
            "phone": "Contato",
            "decir": "Uso DECIR",
            "district": "Distrito",
            "address": "Morada",
            "lat": "Latitude",
            "lng": "Longitude",
            "air_base_type": "Tipo"
        },
        "help": {
            "phone": "É possivel configurar múltiplos telefone/telemóvel separados por <b>,</b> ou <b>;</b>",
            "decir": "Ex - CMA-DECIR",
            "lat": "Ex - 40° 26′ 46″ N ou 40° 26′ 45.9996″ N",
            "lng": "Ex - 79° 58′ 56″ W ou 79° 58′ 55.2″ E"
        }
    },
    "category_types": {
        "titles": "Tipos de Categoria",
        "title": "Tipo de Categoria",
        "model": {
            "order": "Ordem",
            "name": "Nome",
            "active": "Ativo"
        },
        "list": {
            "order": "@:category_types.model.order",
            "name": "@:category_types.model.name",
            "active": "@:category_types.model.active",
        },
    },
}

